import { render, staticRenderFns } from "./PostDate.vue?vue&type=template&id=257d7e54&"
import script from "./PostDate.vue?vue&type=script&lang=js&"
export * from "./PostDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257d7e54')) {
      api.createRecord('257d7e54', component.options)
    } else {
      api.reload('257d7e54', component.options)
    }
    module.hot.accept("./PostDate.vue?vue&type=template&id=257d7e54&", function () {
      api.rerender('257d7e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/components/PostDate.vue"
export default component.exports